const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

// Shared by the artwork, drag target and captured photo so all three stay aligned.
export function landingCourtyardLayout(bounds, mode) {
  const width = bounds.right - bounds.left;
  const height = bounds.bottom - bounds.top;
  const pixelsPerUnit = bounds.pixelsPerUnit || 1;
  const scale = Math.max(width / 1672, height / 941);
  const art = {
    width: 1672 * scale,
    height: 941 * scale,
    y: bounds.top + (height - 941 * scale) * .75,
  };
  // Centre the entrance in portrait crops; the Fantasy doorway sits further right.
  art.x = clamp(bounds.left + width / 2 - art.width * (mode === 'fantasy' ? .58 : .5), bounds.right - art.width, bounds.left);
  const binHeight = Math.min(Math.max(94 / pixelsPerUnit, 150 * scale), height * .27);
  const binWidth = binHeight * 275 / 456;
  const binCenter = clamp(art.x + 1210 * scale, bounds.left + width * .63, Math.min(bounds.left + width * .77, bounds.right - 24 / pixelsPerUnit - binWidth / 2));
  const ground = Math.min(art.y + 760 * scale, bounds.safeBottom ?? bounds.bottom - 168 / pixelsPerUnit);
  const bin = { x: binCenter - binWidth / 2, y: ground - binHeight, width: binWidth, height: binHeight };
  const mouth = { x: binCenter, y: bin.y + binHeight * .12, rx: binWidth * .43, ry: binHeight * .04 };
  // The painted barrel already includes its perspective. Keep its rim level
  // and sides upright rather than skewing the whole object with the paving.
  const padding = 18 / pixelsPerUnit;
  const drop = { left: bin.x - padding, right: bin.x + binWidth + padding, top: bin.y - padding, bottom: ground };
  return { art, bin, mouth, drop, ground };
}
